import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { throwApiError } from "../errorHandler";
import { getBuildVersion } from "../getDefaultHeaders";
import { UserPreferences } from "../../types/userPreferences";

/**
 * Save user preferences to Collins API
 * @param userId - The DMN user _id (MongoDB ObjectId) to save preferences for.
 * @param preferences - The preferences to save
 * @returns The saved preferences from the API
 */
export const saveUserPreferences = async (
  userId: string,
  preferences: UserPreferences
): Promise<UserPreferences> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  if (!userId) {
    throw new Error("Unable to resolve user ID");
  }

  const response = await fetch(
    `${environmentVars?.COLLINS_API_BASE_URL}/users/${userId}/preferences`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "X-Build-Version": getBuildVersion()
      },
      body: JSON.stringify({
        locale: preferences.locale,
        evo_feed_subscriptions: preferences.evo_feed_subscriptions
      })
    }
  );

  if (!response.ok) {
    await throwApiError(response, "Error saving user preferences");
  }

  return await response.json();
};
